import { IconInformationOutline } from '@icons/IconInformationOutline'
import { MarkdownDocumentationHover } from '../MdTextComponent/MarkdownDocumentationHover'

export function DocumentationButton({ documentation }: { documentation: string | undefined }) {
  if (!documentation) return null
  return (
    <MarkdownDocumentationHover documentation={documentation}>
      <button type="button" className="inline-flex shrink-0 border-0 bg-transparent p-0">
        <IconInformationOutline className="size-3.5 text-foreground/70" />
      </button>
    </MarkdownDocumentationHover>
  )
}
